export default __webpack_public_path__ + "static/media/icon-close-grey.d5e529df.svg";